import api from '@/common/api';

const localState = () => ({
  dashboardArticles: null,
  quotes: null,
  statistics: {
    commercial_count: null,
    reviews_count: null,
    coin_count: null,
  },
});

const actions = {
  async getDashboardArticles(state) {
    const response = await api.get(
      'public/articles/',
      { page_size: 3 },
    );

    if (response.status === 200) {
      state.commit('setDashboardArticles', response.data.results);
    }
    return response;
  },
  async getStatistics(state) {
    const response = await api.get('public/sites/statistics/');
    state.commit('setStatistics', response.data);
    return response;
  },
};

const getters = {
  dashboardArticles(state) {
    return state.dashboardArticles;
  },
  quotes(state) {
    return state.quotes;
  },
  statistics(state) {
    return state.statistics;
  },
};

const mutations = {
  setDashboardArticles(state, payload) {
    state.dashboardArticles = payload;
  },
  setQuotes(state, payload) {
    state.quotes = payload.map((quote) => {
      const data = quote;
      data.websiteUrl = data.website || data.organisation.website;
      return data;
    });
  },
  setStatistics(state, payload) {
    state.statistics = payload;
  },
};

export default {
  namespaced: true,
  state: localState,
  getters,
  actions,
  mutations,
};
